import React from "react";
import { GetServerSideProps } from "next";
import { useRouter } from "next/router";
import {
  Card,
  CardHeading,
  CardSubHeading
} from "styles/pages/web-checkout.styles";
import { useAuth } from "stores/auth/auth-context";
import { LoginBackground } from "components/web-checkout/login-background/login-background";
import { ProfileSelection } from "components/web-checkout/profile-selection/profile-selection";

const SelectStudent = (): JSX.Element => {
  const router = useRouter();
  const { user } = useAuth();
  const { userData, setUserData } = user;

  return (
    <LoginBackground routerPath={router.pathname}>
      <Card>
        <CardHeading>
          Pergi wisata ke pulau Bali, senang liat CoFriends kembali!
        </CardHeading>
        <CardSubHeading>
          Mau pakai profil yang mana buat belajar hari ini?
        </CardSubHeading>
        <ProfileSelection
          userData={userData}
          setUserData={setUserData}
          isLoginPage={true}
        />
      </Card>
    </LoginBackground>
  );
};
export const getServerSideProps: GetServerSideProps = async () => {
  return {
    props: {}
  };
};
SelectStudent.requireAuth = true;
export default SelectStudent;
